import { GetListResult, GetOneParams, GetOneResult, RaRecord, UpdateParams, UpdateResult } from 'react-admin';
import { getJson, putJson } from '../../../utils/api';
import IHandler from './IHandler';

export default class AdminConfigCreditDecisionHandler implements IHandler {
  static route = '/admin/settings';
  static resourceIdName = 'id';

  static async getListHandler<RecordType extends RaRecord = any>(): Promise<GetListResult<RecordType>> {
    return getJson(`${this.route}`, process.env.REACT_APP_BASE_CREDIT_DECISION_API_URL).then(async (response) => {
      let { data: responseData } = await response.json();

      responseData = responseData.Items ?? responseData;
      responseData = responseData?.length > 0 ? responseData : [];

      responseData = responseData.map((data: any) => {
        const result = {
          ...data,
        };

        return {
          ...result,
        };
      });

      return {
        data: responseData,
        total: responseData.length,
      };
    });
  }

  static async getOneHandler<RecordType extends RaRecord = any>(
    resource: string,
    params?: GetOneParams<any>
  ): Promise<GetOneResult<RecordType>> {
    const id = params?.id;

    return getJson(`${this.route}/${id}`, process.env.REACT_APP_BASE_CREDIT_DECISION_API_URL).then(async (response) => {
      const { data } = await response.json();

      return {
        data: {
          ...data,
        },
      };
    });
  }

  static async updateHandler<RecordType extends RaRecord = any>(
    resource: string,
    params?: UpdateParams<any>
  ): Promise<UpdateResult<RecordType>> {
    const payload = params?.data || {};
    const id = params?.id;
    return putJson(`${this.route}/${id}`, payload, process.env.REACT_APP_BASE_CREDIT_DECISION_API_URL).then(
      async (response) => {
        const { data } = await response.json();

        return {
          data: {
            ...data,
          },
        };
      }
    );
  }
}
